export default {
  title: `
    أطلق إمكاناتك في البرمجة <br /> مع دورات SkillSynergy المباشرة!
  `,
  meeting: "احجز استشارة مجانية",
};
